<div class="hd-center-fears">
  <header class="hd-center-fears__header">
    <h3 class="hd-center-fears__title">{{ vm().title }}</h3>
  </header>

  <!-- Rapport-tekst over de angsten van dit bewustzijnscentrum -->
  @for (paragraph of vm().paragraphs; track $index) {
    <p class="hd-center-fears__text">{{ paragraph }}</p>
  }

  <!-- Cheat-sheet-blokjes + driehoek-diagram; klikken springt naar de detailsectie -->
  <div class="hd-center-fears__hero">
    <div class="hd-center-fears__cards">
      @for (gate of vm().definition.gates; track gate) {
        <button
          type="button"
          class="hd-center-fears__card-button"
          [attr.data-hero-gate]="gate"
          [title]="vm().jumpHint"
          (click)="scrollToGate(gate)">
          <hd-fear-card [gate]="gate" size="compact" />
        </button>
      }
    </div>
    <img class="hd-center-fears__triangle" [src]="vm().definition.triangleAsset" [alt]="vm().title" (load)="onTriangleLoad()" />
  </div>

  <!-- Per poort de volledige angst-sectie uit het rapport -->
  <div class="hd-center-fears__sections">
    @for (gate of vm().definition.gates; track gate) {
      <hd-fear-section class="hd-center-fears__section" [gate]="gate" cardSize="compact" />
    }
  </div>
</div>
